module.exports = __webpack_public_path__ + "media/images/siq_shield-09320ee600afdbac2d083b61b8076962.svg";